import React from 'react'

export default function Loading() {
    return (
        <div className="loading-wrapper">
            <div className="loading d-flex align-items-center justify-content-center">
                <img src="https://i.pinimg.com/originals/0e/f3/bb/0ef3bb66d9216fffcea9022628f7bb26.gif" alt="gif"/>
            </div>
        </div>
    )
}
